var e={content:"styles_content__JkHQX",header:"styles_header__d3wE0"};export{e as default};
